import React from "react";
import "./App.scss";
import Login from "./pages/Login/Login";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Register from "./pages/Register/Register";
import ApplicationHistory from "./pages/ApplicationHistory/ApplicationHistory";
import MyAccount from "./pages/MyAccount/MyAccount";
import Balance from "./components/Balance/Balance";
import ActivateAccount from "./pages/ActivateAccount/ActivateAccount";
import ChangePassword from "./pages/ChangePassword/ChangePassword";
import ConfirmPassword from "./pages/ConfirmPassword/ConfirmPassword";
import ChangeEmail from "./pages/ChangeEmail/ChangeEmail";
import ConfirmNewEmail from "./pages/ConfirmNewEmail/ConfirmNewEmail";
import ReadyForPayment from "./pages/ReadyForPayment/ReadyForPayment";
import MessagesList from "./pages/MessagesList/MessagesList";
import BalanceList from "./pages/BalanceList/BalanceList";
import Queue from "./components/Queue/Queue";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Users from "./pages/Users/Users";
import UserDetails from "./pages/UserDetails/UserDetails";
import LinkPayment from "./pages/LinkPayment/LinkPayment";
import ReadyForPaymentLink from "./pages/ReadyForPayment/ReadyForPaymentLink";
import SearchResults from "./pages/SearchResults/SearchResults";
import RegisterEmployee from "./pages/RegisterEmployee/RegisterEmployee";
import ManagerEmployees from "./pages/ManagerEmployees/ManagerEmployees";
import ApplicationsList from "./pages/ApplicationsList/ApplicationsList";
import Services from "./pages/Services/Services";
import CreateService from "./pages/CreateService/CreateService";
import EditService from "./pages/EditService/EditService";
import Committee from "./pages/LandingPage/pages/Committee/Committee";
import EventsList from "./pages/LandingPage/pages/EventsList/EventsList";
import Events from "./pages/LandingPage/pages/Events/Events";
import Agenda from "./pages/LandingPage/pages/Agenda/Agenda";
import Program from "./pages/LandingPage/pages/Program/Program";
import News from "./pages/LandingPage/pages/News/News";
import NewsDetails from "./pages/LandingPage/pages/NewsDetails/NewsDetails";
import Participants from "./pages/LandingPage/pages/Participants/Participants";
import Home from "./pages/LandingPage/pages/Home/Home";
import History from "./pages/LandingPage/pages/History/History";
import AboutMctag from "./pages/LandingPage/pages/AboutMctac/AboutMctag";
import AboutHub from "./pages/LandingPage/pages/AboutHub/AboutHub";
import RegionalRepresentatives from "./pages/LandingPage/pages/RegionalRepresentatives/RegionalRepresentatives";
import CreateApplication from "./pages/CreateApplication/CreateApplication";
import EditUserApplication from "./pages/EditUserApplication/EditUserApplication";
import EditBrokerApplication from "./pages/EditBrokerApplication/EditBrokerApplication";
import BrokersApplicationsList from "./pages/BrokersApplicationsList/BrokersApplicationsList";

import OtherApplicationsList from "./pages/OtherApplicationsList/OtherApplicationsList";
import ManagersApplicationsList from "./pages/ManagersApplicationsList/ManagersApplicationsList";
import EditManagerApplication from "./pages/EditManagerApplication/EditManagerApplication";
import AdminApplicationsList from "./pages/AdminApplicationList/AdminApplicationsList";
import AdminUsers from "./pages/AdminUsers/AdminUsers";
import AdminUserDetails from "./pages/AdminUserDetails/AdminUserDetails";
import SignIn from "./pages/SignIn/SignIn";
import UpcomingNewsDetails from "./pages/LandingPage/pages/UpcomingNewsDetails/UpcomingNewsDetails";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/applications" element={<ApplicationsList />} />
        <Route
          path="/brokersApplications"
          element={<BrokersApplicationsList />}
        />
        <Route path="/admin/applications" element={<AdminApplicationsList />} />
        <Route
          path="/managerApplications"
          element={<ManagersApplicationsList />}
        />
        <Route path="/home" element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signIn" element={<SignIn />} />
        <Route path="/register" element={<Register />} />
        <Route path="/createApplication" element={<CreateApplication />} />
        <Route path="/application/:id" element={<EditUserApplication />} />
        <Route
          path="/broker/application/:id"
          element={<EditBrokerApplication />}
        />
        <Route
          path="/manager/application/:id"
          element={<EditManagerApplication />}
        />

        <Route path="/otherApplications" element={<OtherApplicationsList />} />
        <Route path="/myAccount" element={<MyAccount />} />
        <Route path="/queue" element={<Queue />} />
        <Route path="/balance" element={<Balance />} />
        <Route path="/activateAccount" element={<ActivateAccount />} />
        <Route path="/changePassword" element={<ChangePassword />} />
        <Route path="/reset-password" element={<ConfirmPassword />} />
        <Route path="/changeEmail" element={<ChangeEmail />} />
        <Route path="/confirmNewEmail" element={<ConfirmNewEmail />} />
        <Route path="/payment/:id" element={<ReadyForPayment />} />
        <Route path="/messages/:id" element={<MessagesList />} />
        <Route path="/balanceList" element={<BalanceList />} />
        <Route path="/users" element={<Users />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/employees" element={<ManagerEmployees />} />
        <Route path="/payment_link" element={<LinkPayment />} />
        <Route path="/payment/link/:id" element={<ReadyForPaymentLink />} />
        <Route path="/user/:id" element={<UserDetails />} />
        <Route path="/admin/user/:id" element={<AdminUserDetails />} />
        <Route path="/register-employee" element={<RegisterEmployee />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/services" element={<Services />} />
        <Route path="/createService" element={<CreateService />} />
        <Route path="/service/:id" element={<EditService />} />
        <Route path="/history" element={<History />} />
        <Route path="/aboutMctac" element={<AboutMctag />} />
        <Route path="/aboutHub" element={<AboutHub />} />
        <Route
          path="/regionalRepresentatives"
          element={<RegionalRepresentatives />}
        />
        <Route
          path="/application/history/:id"
          element={<ApplicationHistory />}
        />
        <Route path="/committee" element={<Committee />} />

        <Route path="/events" element={<EventsList />} />
        <Route path="/events/:id" element={<Events />} />
        <Route path="/agenda/:id" element={<Agenda />} />
        <Route path="/program/:id" element={<Program />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/:id" element={<NewsDetails />} />
        <Route path="/news/upcoming-events" element={<UpcomingNewsDetails />} />
        <Route
          path="/news/upcoming-events/:city"
          element={<UpcomingNewsDetails />}
        />
        <Route path="/participants/:id" element={<Participants />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
